/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Link } from '@carbon/react';

import * as Styled from 'experiments/ai-features/feel-copilot/IntroContainer.styled';
import { feelCopilotDocsLink } from 'experiments/ai-features/feel-copilot/feel-copilot-docs-link';
import { ExamplePrompt } from 'experiments/ai-features/feel-copilot/ExamplePrompt';

const COPILOT_INTRO_PROMPT = 'What can the Copilot do?';
const FIX_THIS_EXPRESSION = 'Fix this expression';
const PROVIDE_CONTEXT_FOR_THIS_EXPRESSION = 'Provide context for this expression';

const CHECK_IF_NUMBER_GREATER = 'Check if a number is greater than 10';
const FIND_DIFFERENCE_BETWEEN_DATES = 'Find the difference between two dates';

const EXPRESSION_EXISTS_EXAMPLES = [COPILOT_INTRO_PROMPT, FIX_THIS_EXPRESSION, PROVIDE_CONTEXT_FOR_THIS_EXPRESSION];
const EXPRESSION_DOESNT_EXIST_EXAMPLES = [COPILOT_INTRO_PROMPT, CHECK_IF_NUMBER_GREATER, FIND_DIFFERENCE_BETWEEN_DATES];

export const IntroContainer = ({ onExamplePromptClick, expression }) => {
  const examplePrompts = expression?.trim() ? EXPRESSION_EXISTS_EXAMPLES : EXPRESSION_DOESNT_EXIST_EXAMPLES;

  return (
    <Styled.Container>
      Chat with the{' '}
      <Link href={feelCopilotDocsLink} aria-label="FEEL Copilot" target="_blank">
        FEEL Copilot
      </Link>{' '}
      for assistance with writing and explaining FEEL expressions.
      <Styled.ExamplePromptGroup>
        {examplePrompts.map((prompt) => {
          return <ExamplePrompt onClick={onExamplePromptClick}>{prompt}</ExamplePrompt>;
        })}
      </Styled.ExamplePromptGroup>
    </Styled.Container>
  );
};
